import { FaArrowLeftLong } from 'react-icons/fa6';
import { TouchableOpacity, View } from 'react-native';
import { THEME_COLORS } from '../../../theme/constants/themeColors';
import styles from './styles';

export default function BackButton(props: any) {
  const { onPress = () => {}, shadow } = props;
  return (
    <TouchableOpacity activeOpacity={0.7} onPress={onPress}>
      <View>
        <View style={styles.container}>
          {/* previous */}
          {/* <FaAngleLeft size={20} color={COLORS.blackColor} /> */}

          <FaArrowLeftLong size={20} color={THEME_COLORS.textColor} />
        </View>
        <View style={styles.subView} />
      </View>
    </TouchableOpacity>
  );
}
